module.exports = __webpack_public_path__ + "img/cp9_02.09b9821c.jpg";